import React from 'react';
import {
  buttonStylesForPrimary,
  buttonStylesForProjects,
  defaultCommandBarButtonStyles,
  titleCommandBarButtonStyles,
} from '../../../../styles/button-styles';
import ViewWrapperWithCommandBar from '../../../Common/Layout/ViewWrapperWithCommandBar';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { Text, DefaultPalette, useTheme } from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';

import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../common/routes';
import SystemClient from '../../../../system/SystemClient';
import MessageCourier from '../../../../lib/MessageCourier';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useAsyncDataCourier from '../../../../common/custom-hooks/useAsyncDataCourier';
import PlanillaPartidoForm from '../../PlanillaPartidoForm';
import ConfeccionPlanillaPartidoView from './ConfeccionPlanillaPartidoView';
import CustomInputIfc from '../../../../lib/FormValidator/Form/CustomInputIfc';
import { PlanillaPartidoContext } from '../../../../system/PlanillaPartido/PlanillaPartidoSystem';
import { PlanillaPartidoReglaJugadorDisponibleCategoriasInferior } from '../../../../system/PlanillaPartidoReglaJugadorDisponibleCategoriasInferior/PlanillaPartidoReglaJugadorDisponibleCategoriasInferior';
import { PlanillaPartido } from '../../../../system/PlanillaPartido/PlanillaPartido';
import { PlanillaPartidoJugador } from '../../../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import ErroresPopUp from './ErroresPopUp';
import {
  MAX_HANDBALL_PLAYERS_PER_TEAM,
  MIN_HANDBALL_PLAYERS_PER_TEAM,
} from './ConfeccionPlanillaPartidoTeam';
import { PlanillaPartidoOficial } from '../../../../system/PlanillaPartidoOficial/PlanillaPartidoOficial';
import { Usuario } from '../../../../system/Usuario/Usuario';

import DialogTemplate from '../../../Common/DialogTemplate';
import { useContainerStyle } from '../../../../common/custom-hooks/useStyles';
import { useMismatchVersion } from '../../../../common/custom-hooks/useMismatchVersion';
import MismatchVersionDialog from '../../../Common/MismatchVersionDialog';

interface IConfeccionPlanillaPartido {
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  setPlanillaPartido: (planillaPartido: PlanillaPartido) => void;
  user: Usuario;
}

const ConfeccionPlanillaPartido = ({
  system,
  courier,
  changeBlockUI,
  setPlanillaPartido,
  user,
}: IConfeccionPlanillaPartido) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [planillaPartidoForm, setPlanillaPartidoForm] = React.useState<PlanillaPartidoForm | undefined>(
    undefined
  );
  const [formIsValid, setFormIsValid] = React.useState(false);
  const [context, setContext] = React.useState<PlanillaPartidoContext | undefined>(undefined);
  const [rules, setRules] = React.useState<PlanillaPartidoReglaJugadorDisponibleCategoriasInferior[]>([]);

  const [showPlanillaEnJuegoDialog, setShowPlanillaEnJuegoDialog] = React.useState<boolean>(false);

  const [showErroresPopUp, setShowErroresPopUp] = React.useState<boolean>(false);
  const [errores, setErrores] = React.useState<string[]>([]);

  const onBlurCustomInput = (customInput: CustomInputIfc) => {
    if (planillaPartidoForm)
      setFormIsValid(
        planillaPartidoForm.getIdInput().getValue()
          ? !planillaPartidoForm.hasErrors()
          : planillaPartidoForm.isValid()
      );
  };

  React.useEffect(() => {
    if (planillaPartidoForm)
      setFormIsValid(
        planillaPartidoForm.getIdInput().getValue()
          ? !planillaPartidoForm.hasErrors()
          : planillaPartidoForm.isValid()
      );
  }, [planillaPartidoForm]);

  const { showMMVersionDialog, isMMVError, onCancelMMV } = useMismatchVersion();

  const onClickSave = async () => {
    let planillaPartido: PlanillaPartido | undefined = undefined;
    try {
      changeBlockUI(true);
      if (!!!planillaPartidoForm?.getArbid1Input().getValue()) {
        courier.messageError(
          'Los datos de la planilla no podrán ser actualizados si no fue ingresado el primer arbitro'
        );
      } else {
        planillaPartido = await system
          .getPlanillaPartidoSystem()
          .save(planillaPartidoForm?.toPlanillaPartido()!);
        setPlanillaPartido(planillaPartido);
        courier.messageSuccess(t('Los datos fueron actualizados correctamente'));
        // await populateForm(planillaPartido);
        const form = PlanillaPartidoForm.buildFromPlanilla(planillaPartido, context!);

        setPlanillaPartidoForm(form);
      }
    } catch (err) {
      courier.messageError(err);
      isMMVError(err); // muestra el dialog
    } finally {
      changeBlockUI(false);
    }
    return planillaPartido;
  };

  const validarInformacionBasica = () => {
    let ret: string[] = [];
    if (
      planillaPartidoForm?.getCjidInput().getValue() === 0 ||
      planillaPartidoForm?.getCjidInput().getValue() === null
    ) {
      ret.push('No posee campo de juego');
    }
    if (planillaPartidoForm?.getFechaHoraInicioInput().getValue() === null) {
      ret.push('No posee Fecha de inicio');
      ret.push('No posee Hora de inicio');
      ret.push('No posee Minuto de inicio');
    } else {
      console.log(planillaPartidoForm?.getHorario());
      if (isNaN(planillaPartidoForm?.getFechaHoraInicioInput().getValue())) {
        ret.push('No posee Fecha de inicio');
        ret.push('No posee Hora de inicio');
        ret.push('No posee Minuto de inicio');
      }
      if (planillaPartidoForm?.getHorario().split(':')[0] === '') {
        ret.push('No posee Hora de inicio');
      }
      if (planillaPartidoForm?.getHorario().split(':')[1] === '') {
        ret.push('No posee Minuto de inicio');
      }
    }
    if (planillaPartidoForm?.getArbid1Input().getValue() === 0) {
      ret.push('No posee Primer arbitro');
    }
    if (
      planillaPartidoForm?.getOfmidLocalInput().getValue() === 0 &&
      !planillaPartidoForm?.getOficialNoRegistradoByEquipoId(
        planillaPartidoForm?.getPartidoInput().getValue().getEqidLocal()
      )
    ) {
      console.log(
        'OFI',
        planillaPartidoForm?.getOficialNoRegistradoByEquipoId(
          planillaPartidoForm?.getPartidoInput().getValue().getEqidLocal()
        )
      );
      ret.push('No posee Oficial de mesa local');
    }
    if (
      planillaPartidoForm?.getOfmidVisitanteInput().getValue() === 0 &&
      !planillaPartidoForm?.getOficialNoRegistradoByEquipoId(
        planillaPartidoForm?.getPartidoInput().getValue().getEqidVisitante()
      )
    ) {
      ret.push('No posee Oficial de mesa visitante');
    }
    return ret;
  };

  const validarEquipos = () => {
    let ret: string[] = [];
    if (planillaPartidoForm) {
      const jugadores = planillaPartidoForm
        ?.getPlanillaPartidoJugadoresInput()
        .getValue() as PlanillaPartidoJugador[];

      const equipoLocalId = planillaPartidoForm.getPartidoInput().getValue().getEqidLocal();
      const equipoVisitanteId = planillaPartidoForm.getPartidoInput().getValue().getEqidVisitante();

      // tomo los jugadores que tengan dorsal asignado
      let jugadoresLocal: PlanillaPartidoJugador[] = jugadores.filter(
        (ppj) => !!ppj.getDorsal() && +ppj.getEqid() === +equipoLocalId
      );
      let jugadoresVisitantes: PlanillaPartidoJugador[] = jugadores.filter(
        (ppj) => !!ppj.getDorsal() && !!ppj.getDorsal() && +ppj.getEqid() === +equipoVisitanteId
      );

      const cantJugadoresLocal = jugadoresLocal.length;
      const cantJugadoresVisitante = jugadoresVisitantes.length;

      const min = MIN_HANDBALL_PLAYERS_PER_TEAM;
      const max = MAX_HANDBALL_PLAYERS_PER_TEAM;

      if (cantJugadoresLocal < min || cantJugadoresLocal > max) {
        ret.push(`La cantidad de jugadores del equipo local debe estar entre ${min} y ${max}`);
      }
      if (cantJugadoresVisitante < min || cantJugadoresVisitante > max) {
        ret.push(`La cantidad de jugadores del equipo visitante debe estar entre ${min} y ${max}`);
      }
      const oficiales = planillaPartidoForm?.getOficialesInput().getValue() as PlanillaPartidoOficial[];

      if (!oficiales.some((ppo) => +ppo.getEqid() === +equipoLocalId)) {
        ret.push('El equipo local no tiene asignado un oficial A');
      }

      if (!oficiales.some((ppo) => +ppo.getEqid() === +equipoVisitanteId)) {
        ret.push('El equipo visitante no tiene asignado un oficial A');
      }
    }

    return ret;
  };

  const validarInicioPartido = () => {
    let ret: string[] = [];
    ret = ret.concat(validarInformacionBasica());
    ret = ret.concat(validarEquipos());
    return ret;
  };

  const onClickIniciarPartido = () => {
    const errors = validarInicioPartido();
    console.log('Errors', errors);
    if (errors.length === 0) {
      onClickSave().then((pp) => {
        if (pp) {
          navigate(`${routes.planilla_partido.route}/${pp.getId()}`);
        }
      });

      // navigate(routes.planilla_partido.route);
    } else {
      setErrores(errors);
      setShowErroresPopUp(true);
    }
  };

  const theme = useTheme();

  const itemsMenu = React.useMemo((): ICommandBarItemProps[] => {
    let ret: ICommandBarItemProps[] = [];
    ret.push(
      {
        key: 'title',
        text: t('Confección de planilla digital'),
        iconProps: {
          iconName: 'AccountActivity',
        },
        onClick: () => {
          navigate(routes.planilla_partido_programado.route);
        },
      },
      {
        key: 'save',
        text: t('Guardar'),
        iconProps: {
          iconName: 'Save',
        },
        buttonStyles: buttonStylesForPrimary(theme),

        onClick: () => {
          onClickSave();
        },
        disabled: !formIsValid,
      },
      {
        key: 'planilla',
        text: t('Iniciar partido'),
        iconProps: {
          iconName: 'AccountActivity',
        },

        onClick: () => onClickIniciarPartido(),
        disabled: !formIsValid,
      },
      {
        key: 'back',
        text: t('Volver'),
        iconProps: {
          iconName: 'Back',
        },
        onClick: () => navigate(routes.planilla_partido_programado.route),
      }
    );
    return ret;
  }, [formIsValid, navigate, planillaPartidoForm, theme]);

  const partido = useAsyncDataCourier(
    () => system.getPartidoSystem().getPartidoIdentifiedBy(String(id)),
    [],
    courier
  );

  React.useEffect(() => {
    const getContext = async () => {
      if (partido) {
        try {
          changeBlockUI(true);
          const hasPlanillaEnJuego = await system
            .getPlanillaPartidoSystem()
            .hasPlanillaEnJuego(partido.getId()!);

          if (!hasPlanillaEnJuego) {
            const context = await system.getPlanillaPartidoSystem().getContextForConfeccion(partido);
            const rules = await system
              .getPlanillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem()
              .getRulesFor(String(partido.getTorid()));
            setRules(rules);
            const planillaPartido = await system
              .getPlanillaPartidoSystem()
              .getPlanillaPartidoIdentifiedByPartidoId(partido.getId()!);
            let form = PlanillaPartidoForm.initialize();
            if (planillaPartido) {
              form = PlanillaPartidoForm.buildFromPlanilla(planillaPartido, context);
            } else {
              form = PlanillaPartidoForm.buildFromPartido(partido, context);
            }
            setPlanillaPartidoForm(form);
            setContext(context);
          } else {
            setShowPlanillaEnJuegoDialog(true);
          }
        } catch (err) {
          courier.messageError(err);
        } finally {
          changeBlockUI(false);
        }
      }
    };
    getContext();
  }, [partido]);

  const containerStyle = useContainerStyle();

  return (
    <ViewWrapperWithCommandBar
      withBorderBottom
      title={''}
      items={itemsMenu}
      overflowButtonStyles={defaultCommandBarButtonStyles}
      variant="highlight"
      titleBody="PlanillaPartidoProgramado"
    >
      <>
        {showErroresPopUp && errores.length > 0 && (
          <ErroresPopUp
            onAccept={() => setShowErroresPopUp(false)}
            showDialog={showErroresPopUp}
            errores={errores}
          />
        )}
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row ">
            <div className="ms-Grid-col ms-lg12 lg-mt-2 mb-2 ">
              <div>
                {partido && (
                  <div className="ms-Grid" style={containerStyle} dir="ltr">
                    <div className="ms-Grid-row padding-1">
                      <div className="ms-Grid-col ms-sm12  text-center">
                        <Text
                          className="mb-1"
                          variant="medium"
                          style={{
                            fontWeight: 450,
                            fontSize: 15,
                          }}
                        >
                          {partido.getTorneo()?.getNombre()} -{' '}
                          {partido.getTorneo()?.getCategoria()?.getNombre()} ({partido.getTorneo()?.getRama()}
                          ) - {partido.getTorneo()?.getDivision()?.getNombre()}
                        </Text>
                      </div>

                      <div className="ms-Grid-col ms-sm12">
                        <div className="ms-Grid-col ms-sm5 text-center">
                          <TeamCardForConfeccion
                            system={system}
                            equipo={partido.getLocal()}
                          ></TeamCardForConfeccion>
                        </div>
                        <div className="ms-Grid-col ms-sm2 text-center" style={{ marginTop: 20 }}>
                          {' '}
                          <Text className="mb-1" variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                            VS.
                          </Text>
                        </div>
                        <div className="ms-Grid-col ms-sm5 text-center">
                          <TeamCardForConfeccion
                            system={system}
                            equipo={partido.getVisitante()}
                          ></TeamCardForConfeccion>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {partido && planillaPartidoForm && context && (
                  <ConfeccionPlanillaPartidoView
                    system={system}
                    courier={courier}
                    changeBlockUI={changeBlockUI}
                    form={planillaPartidoForm}
                    partido={partido}
                    onBlurCustomInput={onBlurCustomInput}
                    context={context}
                    rules={rules}
                    torneo={partido.getTorneo()!}
                    user={user}
                  ></ConfeccionPlanillaPartidoView>
                )}
              </div>
            </div>
          </div>

          <MismatchVersionDialog
            onCancel={onCancelMMV}
            showDialog={showMMVersionDialog}
          ></MismatchVersionDialog>

          <DialogTemplate
            showDialog={showPlanillaEnJuegoDialog}
            toggleShowDialog={() => navigate(routes.planilla_partido_programado.route)}
            title={`Ya hay una planilla en juego!`}
            onAccept={() => navigate(routes.planilla_partido_programado.route)}
            onCancel={() => {}}
            hideCancelButton
            acceptText="Ir a partidos programados"
            cancelText=""
            minWidth={600}
          >
            <Text className="error-message" variant="medium">
              No podes confeccionar una planilla para este partido porque ya tiene una planilla en juego
            </Text>
          </DialogTemplate>
        </div>
      </>
    </ViewWrapperWithCommandBar>
  );
};

export const TeamCardForConfeccion = (props: any) => {
  return (
    <div>
      <div style={{ display: 'inline-block' }}>
        <Image
          src={
            props.equipo.getClub()?.getEscudo()
              ? props.system.getClubSystem().getUrlForImage(props.equipo.getClub()!.getEscudo())
              : '/images/escudo_default.jpg'
          }
          imageFit={ImageFit.cover}
          maximizeFrame
          styles={{
            root: {
              borderRadius: '50%',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
              width: '50px',
              height: '50px',
            },
          }}
        />
      </div>
      <Text
        className="mb-1"
        variant="medium"
        style={{
          fontWeight: 600,
          fontSize: 20,
          position: 'relative',
          bottom: '18px',
          left: '10px',
        }}
      >
        {props.equipo.getClub()?.getNombre()} {props.equipo.getNombreOrden()}
      </Text>
    </div>
  );
};

export default ConfeccionPlanillaPartido;
